export const serviceWorkerBroadcastChannel = 'service-worker';
